import type { Normalizer } from '@change-corgi/fcm/normalizers';
import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

const normalizeNumberRecordShape = createShapeNormalizer({
	type: 'record',
	shape: { type: 'number' },
});

type SsrCacheLifetimeSecondsOverride = Readonly<Record<string, number>>;

export const normalizeSsrCacheLifetimeSecondsOverride: Normalizer<SsrCacheLifetimeSecondsOverride> = (
	value: unknown,
) => {
	const objectValue = normalizeNumberRecordShape(value);

	return Object.entries(objectValue)
		.filter(([_name, val]) => val && val > 0)
		.reduce(
			(acc, [name, val]) => ({
				...acc,
				[name]: val,
			}),
			{},
		);
};

export const FCM_CORGI_SSR_CACHE_LIFETIME_SECONDS_OVERRIDE = defineFcm('corgi_ssr_cache_lifetime_seconds_override')
	.asJson(normalizeSsrCacheLifetimeSecondsOverride)
	.withDefault({} as SsrCacheLifetimeSecondsOverride)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'corgi SSR',
		description: `Used to override the default server caching lifetime (default it 1 minute).
			Each property should match the route's id in corgi for which the cache lifetime should be overridden.
			Values should be in seconds.`,
		import: false,
		template: {
			'route-id': 120,
		},
	});
